import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = {
    is_member_in_event: false,
    has_permission:false,
    event_edit_link: '',
    logged_in_client: {
      full_name: '',
      email: '',
      id: '',
      image: '',
      client_slug: '',
    },
};

export const clientDataSlice = createSlice({
  name: 'clientData',
  initialState,
  reducers: {
    setClientData: (state, { payload: data }) => {
      return data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setClientData } = clientDataSlice.actions;

export const getClientData = (state: RootState) => state.clientData;

export default clientDataSlice.reducer;
